/* ABCD — EU / US / UK size switch on the product page (same look as Olyx).
   Size values stay "EU 42 / US M 8.5 / US W 10 / UK 7.5" in Shopify; only the
   button text changes. The visitor's choice is remembered (localStorage
   "abcd-size-unit") and layout/theme.liquid reads it on the next page too.
   ASICS: some imported values use a Nike chart, so for ASICS we show the
   official ASICS conversion (same values Olyx shows). */
(function () {
  'use strict';
  if (window.__abcdSizeSwitch) return;
  window.__abcdSizeSwitch = true;

  var KEY = 'abcd-size-unit';
  var UNITS = ['EU', 'US', 'UK'];

  // official ASICS men's / unisex chart: EU -> [US M, US W, UK]
  var ASICS = {
    '36': ['4', '5.5', '3'], '37': ['4.5', '6', '3.5'], '37.5': ['5', '6.5', '4'],
    '38': ['5.5', '7', '4.5'], '39': ['6', '7.5', '5'], '39.5': ['6.5', '8', '5.5'],
    '40': ['7', '8.5', '6'], '40.5': ['7.5', '9', '6.5'], '41.5': ['8', '9.5', '7'],
    '42': ['8.5', '10', '7.5'], '42.5': ['9', '10.5', '8'], '43.5': ['9.5', '11', '8.5'],
    '44': ['10', '11.5', '9'], '44.5': ['10.5', '12', '9.5'], '45': ['11', '12.5', '10'],
    '46': ['11.5', '13', '10.5'], '46.5': ['12', '13.5', '11'], '47': ['12.5', '14', '11.5']
  };

  var ADULT = /^EU\s*([\d.]+)\s*\/\s*US\s*M\s*([\d.]+)\s*\/\s*US\s*W\s*([\d.]+)\s*\/\s*UK\s*([\d.]+)$/i;
  var KIDS = /^EU\s*([\d.]+)\s*\/\s*US\s*([\d.]+\s*[CY])\s*\/\s*UK\s*([\d.]+)$/i;

  function read() {
    try { var v = localStorage.getItem(KEY); if (UNITS.indexOf(v) > -1) return v; } catch (e) {}
    var c = ' ' + document.documentElement.className + ' ';
    if (c.indexOf(' olyx-sizes-us ') > -1) return 'US';
    if (c.indexOf(' olyx-sizes-uk ') > -1) return 'UK';
    return 'EU';
  }

  var unit = read();

  function sizeFor(raw, asics) {
    raw = String(raw || '').trim();
    var m = ADULT.exec(raw);
    if (m) {
      var us = m[2], w = m[3], uk = m[4];
      if (asics && ASICS[m[1]]) { us = ASICS[m[1]][0]; w = ASICS[m[1]][1]; uk = ASICS[m[1]][2]; }
      if (unit === 'US') return 'M ' + us + ' / W ' + w;
      if (unit === 'UK') return uk;
      return m[1];
    }
    m = KIDS.exec(raw);
    if (m) {
      if (unit === 'US') return m[2].replace(/\s+/g, '');
      if (unit === 'UK') return m[3];
      return m[1];
    }
    return null;
  }

  function isAsics(el) {
    var scope = el.closest('.shopify-section') || document;
    var json = scope.querySelector('script[data-product-json]');
    var hay = '';
    try {
      var p = JSON.parse(json.textContent).product;
      hay = [p.title, p.vendor, p.type].join(' ');
    } catch (e) {
      hay = document.title;
    }
    return /\basics\b/i.test(hay);
  }

  function bar() {
    var wrap = document.createElement('div');
    wrap.className = 'Msc__Bar';
    var html = '<div class="Msc__Seg" role="group" aria-label="Size system">';
    UNITS.forEach(function (u) {
      html += '<button type="button" class="Msc__Opt" data-unit="' + u + '" aria-pressed="false">' + u + '</button>';
    });
    wrap.innerHTML = html + '</div>';
    return wrap;
  }

  function render() {
    document.querySelectorAll('.OlyxInline--size').forEach(function (box) {
      var list = box.querySelector('.OlyxInline__SizeList');
      if (!list) return;
      var btns = list.querySelectorAll('.OlyxSizeBtn');
      if (!btns.length || sizeFor(btns[0].getAttribute('data-olyx-val'), false) == null) return;

      if (box.getAttribute('data-abcd-asics') == null) {
        box.setAttribute('data-abcd-asics', isAsics(box) ? '1' : '0');
      }
      var asics = box.getAttribute('data-abcd-asics') === '1';

      var seg = box.querySelector('.Msc__Bar');
      if (!seg) {
        seg = bar();
        list.parentNode.insertBefore(seg, list);
      }
      seg.querySelectorAll('.Msc__Opt').forEach(function (o) {
        var on = o.getAttribute('data-unit') === unit;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var label = box.querySelector('.OlyxInline__Label');
      if (label) {
        var t = label.textContent;
        var nt = /\((EU|US|UK)\)/.test(t)
          ? t.replace(/\((EU|US|UK)\)/, '(' + unit + ')')
          : t.replace(/\s*:?\s*$/, '') + ' (' + unit + '):';
        if (nt !== t) label.textContent = nt;
      }

      btns.forEach(function (b) {
        var want = sizeFor(b.getAttribute('data-olyx-val'), asics);
        if (want == null || b.getAttribute('data-abcd-want') === want) return;
        var low = b.querySelector('.OlyxSizeBtn__LowStock');
        b.textContent = want;
        if (low) b.appendChild(low);
        // let olyx-fixes.js recompute its duplicate-size handling from the new text
        b.removeAttribute('data-olyx-label');
        b.removeAttribute('data-olyx-html');
        b.removeAttribute('data-olyx-orig');
        b.setAttribute('data-abcd-want', want);
      });
    });
  }

  function setUnit(u) {
    if (UNITS.indexOf(u) === -1 || u === unit) return;
    unit = u;
    try { localStorage.setItem(KEY, u); } catch (e) {}
    var cl = document.documentElement.classList;
    UNITS.forEach(function (x) { cl.remove('olyx-sizes-' + x.toLowerCase()); });
    cl.add('olyx-sizes-' + u.toLowerCase());
    render();
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.Msc__Opt[data-unit]');
    if (!o) return;
    e.preventDefault();
    setUnit(o.getAttribute('data-unit'));
  });

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; render(); }, 40);
  }

  function start() {
    render();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    setTimeout(render, 600);
    setTimeout(render, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', render);
})();
